import { render, staticRenderFns } from "./SearchProcess.vue?vue&type=template&id=6779325b"
import script from "./SearchProcess.vue?vue&type=script&lang=js"
export * from "./SearchProcess.vue?vue&type=script&lang=js"
import style0 from "./SearchProcess.vue?vue&type=style&index=0&id=6779325b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports